export { Nickname } from './nickname.page';
